export default {
  custom: {
    label: '定制可玩广告',
    version: {
      table: {
        name: '项目名称',
        creator: '创建者',
      },
      apply: {
        label: '仅限推送账号',
        delete: {
          label: '删除账号信息',
          describe: '删除后将无法恢复，确定删除吗？',
        },
      },
      batch: {
        selected: '已选中{num}条',
        selectall: '全选',
        reverse: '反选',
        cancel: '全部取消',
        apply: '推送',
        delete: '删除',
      },
    },
    describe:
      '我们提供高质量的创意定制与多样化的营销策划服务，满足您不同的营销目标和场景。',
  },
}
